import { Component, OnInit, ElementRef } from '@angular/core';
import * as d3 from 'd3';

@Component({
  selector: 'app-small-consume-line-chart',
  template: `
    <div class="chart-container">
      <svg></svg>
    </div>
  `,
  styles: [`
    .chart-container {
      width: 100%;
      height: 200px;
    }
    svg {
      width: 100%;
      height: 100%;
    }
  `]
})
export class SmallConsumeLineChartComponent implements OnInit {
  private data = [
    { month: 'Ene', consumption: 20 },
    { month: 'Feb', consumption: 50 },
    { month: 'Mar', consumption: 30 }
  ];

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    this.createChart();
  }

  private createChart(): void {
    const element = this.el.nativeElement.querySelector('svg');
    const margin = { top: 20, right: 20, bottom: 50, left: 60 }; // Adjusted bottom and left margins for labels
    const width = element.clientWidth - margin.left - margin.right;
    const height = element.clientHeight - margin.top - margin.bottom;
  
    const svg = d3.select(element)
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom)
      .append('g')
      .attr('transform', `translate(${margin.left},${margin.top})`);
  
    // Scales
    const x = d3.scalePoint()
      .domain(this.data.map(d => d.month))
      .range([0, width])
      .padding(0.5);
  
    const y = d3.scaleLinear()
      .domain([0, d3.max(this.data, d => d.consumption) || 0])
      .nice()
      .range([height, 0]);
  
    // Axes
    svg.append('g')
      .attr('transform', `translate(0,${height})`)
      .call(d3.axisBottom(x));
  
    svg.append('g')
      .call(d3.axisLeft(y).ticks(4));
  
    // Add vertical axis label
    svg.append('text')
      .attr('transform', 'rotate(-90)')
      .attr('x', -height / 2)
      .attr('y', -40) // Adjust position for better alignment
      .attr('text-anchor', 'middle')
      .attr('fill', '#000')
      .text('Lts');
  
    // Line generator (curved line)
    const line = d3.line<any>()
      .x(d => x(d.month) || 0)
      .y(d => y(d.consumption))
      .curve(d3.curveCardinal); // Makes the line curved
  
    // Line path
    svg.append('path')
      .datum(this.data)
      .attr('fill', 'none')
      .attr('stroke', '#D3A913') // Set the line color
      .attr('stroke-width', 2)
      .attr('d', line);
  
    // Points
    svg.selectAll('.dot')
      .data(this.data)
      .enter().append('circle')
      .attr('class', 'dot')
      .attr('cx', d => x(d.month) || 0)
      .attr('cy', d => y(d.consumption))
      .attr('r', 4)
      .attr('fill', '#D3A913'); // Match the point color with the line
  
    // Add line indicator
    // svg.append('text')
      // .attr('x', width - 100) // Position near the end of the line
      // .attr('y', y(this.data[this.data.length - 1].consumption) - 10) // Slightly above the last point
      // .attr('text-anchor', 'end')
      // .attr('fill', '#D3A913')
      // .style('font-size', '12px')
      // .text('Litros consumidos');
  }
}
